<template>
  <div class="base-layout"><slot></slot></div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
@import "../assets/style/_variables.scss";
.base-layout {
  top: 0;
  overflow-y: hidden;
  overflow-x: hidden;
  position: relative;
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  height: 100vh;
  background: url("../assets/omi-background.svg");
  background-size: cover;
  background-position: center;
}
</style>
